import { ref } from 'vue';
import { useAuthenticatedFetch } from '../auth/useAuthenticatedFetch';
import { IncomePayment, IncomePaymentRequest } from '@/interfaces/income';
import {
  incomesPayments,
  clubUUID,
  incomes,
  income_regulations_amount,
  income_regulations_amount_by_day,
} from "@/shared/state";
import { IncomeRegulationSalesQueryParams } from '@/interfaces/stats';


const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function useIncomePayment() {
    const errorIncomePayment = ref<boolean | false>(false);
    const isRequestIncomePayment = ref<boolean | false>(false);
    const getPayments = async (income_id: number | string) => {
        try {
            isRequestIncomePayment.value = true
            errorIncomePayment.value = false
            const response = await authenticatedFetch(`${API_URL}incomes-payments/${income_id}/${clubUUID.value}`, {
                method: 'GET'
            }, false, '', false);
            if (response?.data) {
                incomesPayments.data = response?.data || []

            }
            isRequestIncomePayment.value = false

        } catch (err: any) {
            errorIncomePayment.value = true;
            isRequestIncomePayment.value = false
        }
    };


    const addPayment = async (body: IncomePaymentRequest) => {
        try {
            isRequestIncomePayment.value = true
            errorIncomePayment.value = false
            const response = await authenticatedFetch(`${API_URL}incomes-payments/store`, {
                method: 'POST',
                body: JSON.stringify(body),
            }, true, '', true);
            if (response) {

                if (response?.data) {
                    //   incomesPayments.data = response?.data || []

                    const index = incomes?.data?.findIndex(income => income?.id === response?.data?.income_id);
                    if (index !== -1) {
                        incomes.data[index].remaining_amount -= response?.data?.amount_paid ?? 0;
                        incomes.data[index].total_amount_paid += response?.data?.amount_paid ?? 0;
                        if (incomes.data[index].remaining_amount <= 0)
                            incomes.data[index].is_paid = 1
                    }
                }

            }
            isRequestIncomePayment.value = false
        } catch (err: any) {
            errorIncomePayment.value = true;
            isRequestIncomePayment.value = false
        }
    };

    const editPayment = async (body: IncomePaymentRequest) => {
        try {
            isRequestIncomePayment.value = true
            errorIncomePayment.value = false
            const response = await authenticatedFetch(`${API_URL}incomes-payments/edit/${body?.id}`, {
                method: 'PUT',
                body: JSON.stringify(body),
            }, true, '', true);
            if (response) {
                const paymentEdited: IncomePayment = response?.data
                const index = incomesPayments?.data?.findIndex(payment => payment?.id === paymentEdited?.id);
                // if (index !== -1) {
                //     incomesPayments.data[index] = paymentEdited;
                // }
            }
            isRequestIncomePayment.value = false
        } catch (err: any) {
            errorIncomePayment.value = true;
            isRequestIncomePayment.value = false
        }
    };

    const deletePayment = async (paymentID: number, incomeID: number, amount_paid: number) => {
        try {
            isRequestIncomePayment.value = true
            errorIncomePayment.value = false
            const response = await authenticatedFetch(`${API_URL}incomes-payments/delete/${paymentID}`, {
                method: 'DELETE'
            }, true, '', true);
            const index = incomesPayments?.data?.findIndex(payment => payment?.id === paymentID);
            if (index !== -1) {
                incomesPayments.data.splice(index, 1);

                const indexIncome = incomes?.data?.findIndex(income => income?.id === incomeID);
                if (indexIncome !== -1) {
                    incomes.data[indexIncome].remaining_amount += amount_paid ?? 0;
                    incomes.data[indexIncome].total_amount_paid -= amount_paid ?? 0;
                    if (incomes.data[indexIncome].remaining_amount > 0)
                        incomes.data[indexIncome].is_paid = 0
                }

            }
            isRequestIncomePayment.value = false
        } catch (err: any) {
            errorIncomePayment.value = true;
            isRequestIncomePayment.value = false
        }
    };



    const fetchIncomeRegulationsStats = async (body: IncomeRegulationSalesQueryParams) => {
        try {
            isRequestIncomePayment.value = true
            errorIncomePayment.value = false
            income_regulations_amount.data = []
            const response = await authenticatedFetch(`${API_URL}incomes-payments/regulations/stats`, {
                method: 'POST',
                body: JSON.stringify(body),
            }, false, '', false);
            if (response) {

                income_regulations_amount.data = response?.regulations
                income_regulations_amount.total = response?.total
            }
            isRequestIncomePayment.value = false
        } catch (err: any) {
            errorIncomePayment.value = true;
            isRequestIncomePayment.value = false
        }
    };

     const fetchIncomeRegulationsStatsByDay = async (
       body: IncomeRegulationSalesQueryParams,
     ) => {
       try {
         isRequestIncomePayment.value = true;
         errorIncomePayment.value = false;
         income_regulations_amount_by_day.data = [];
         const response = await authenticatedFetch(
           `${API_URL}incomes-payments/regulations/stats`,
           {
             method: "POST",
             body: JSON.stringify(body),
           },
           false,
           "",
           false,
         );
         if (response) {
           isRequestIncomePayment.value = false;
           income_regulations_amount_by_day.data = response?.regulations;
           income_regulations_amount_by_day.total = response?.total;
         }
         isRequestIncomePayment.value = false;
       } catch (err: any) {
         errorIncomePayment.value = true;
         isRequestIncomePayment.value = false;
       }
     };

    return {
        fetchIncomeRegulationsStatsByDay,
        fetchIncomeRegulationsStats,
        getPayments,
        addPayment,
        editPayment,
        deletePayment,
        isRequestIncomePayment,
        errorIncomePayment
    };
}
